import React from 'react';
import {observer} from 'mobx-react';
import s from '../s';
import ModalSimple from '../../global/modal-simple';
import AbTestStore, {ABTestKeys} from '../../global/store/ab-test-store';
import {Portal} from '../../util';

/** The glass section's two modals, "Glass Information" (modal-glass) and "Acrylic Information" (modal-plexi-info), shared by both product page layouts. */
const GlassInfoModals: React.FC = observer(() => (
    <>
        <ModalSimple
            id="modal-glass"
            title="Glass Information"
        >
            <div>
                <div className="header-std">Clear (Standard {s.prod.AllowGlassID1 === 2 || s.ps.use_plexi ? 'Acrylic' : 'Glass'})</div>
                <p style={{marginBottom: 0}}>Clear standard {s.prod.AllowGlassID1 === 2 || s.ps.use_plexi ? 'acrylic' : 'glass'} blocks 45% of UV light. Use when UV exposure is not a concern.</p>
                {!AbTestStore.ABIsVariant(ABTestKeys.product_glass, 1) && s.prod.AllowGlassID2 > 0 && (
                    <div>
                        <div className="header-std">Reflection Control</div>
                        <p>Matte finish to reduce glare and blocks 45% of UV light. Diminishes unwanted glare.</p>
                    </div>
                )}
                {!AbTestStore.ABIsVariant(ABTestKeys.product_glass, 1) && s.prod.AllowGlassID3 > 0 && (
                    <div>
                        <div className="header-std">Conservation UV Protection</div>
                        <p>Blocks up to 99% of UV light. Offers maximum protection against fading.</p>
                    </div>
                )}
                {s.prod.AllowGlassID4 > 0 && (
                    <div>
                        <div className="header-std">Conservation UV + Reflection Control</div>
                        <p>Blocks up to 99% of UV light, matte finish reduces glare. Offers maximum protection against fading and unwanted glare.</p>
                    </div>
                )}
                {s.prod && s.prod.IsFrame && s.prod.ProductID !== 84054 && s.prod.ProductID !== 70214 && s.prod.AllowGlassID2 > 0 && (
                    <div style={{marginTop: 8}}>
                        <picture>
                            <source
                                type="image/webp"
                                srcSet={`https://${Portal?.CDNDomain}/images/cached/general/glass-all.webp`}
                            />
                            <img
                                src={`https://${Portal?.CDNDomain}/images/cached/general/glass-all.png`}
                                alt="Glass Info"
                                style={{width: '100%'}}
                            />
                        </picture>
                    </div>
                )}
                {(!s.prod.AllowGlassID2 || s.prod.AllowGlassID2 < 1) && (
                    <div style={{marginTop: 8}}>
                        <picture>
                            <source
                                type="image/webp"
                                srcSet={`https://${Portal?.CDNDomain}/images/cached/general/glass-46.webp`}
                            />
                            <img
                                src={`https://${Portal?.CDNDomain}/images/cached/general/glass-46.jpg`}
                                alt="Glass Info"
                                style={{width: '100%'}}
                            />
                        </picture>
                    </div>
                )}
            </div>
        </ModalSimple>
        <ModalSimple
            id="modal-plexi-info"
            title="Acrylic Information"
        >
            <div>
                <div className="b">Why does this frame have acrylic?</div>
                <div>
                    Due to the large size of this frame, we use professional-grade acrylic to reduce the possibility of breakage during shipping. Our high-quality acrylic features the same level of document protection as our standard clear glass, and we also offer upgraded acrylic options for added
                    protection.
                </div>
            </div>
        </ModalSimple>
    </>
));

export default GlassInfoModals;
